export default __webpack_public_path__ + "static/media/orgName.265cdd69.jpg";